import * as _ from 'lodash-es';

// setting
class PlayController {
  constructor(target, play, pause) {
    this.target = target || null;
    this.play = play;
    this.pause = pause;
  }

  // init
  init() {
    // set status
    this.play.button.index = 'play';
    this.pause.button.index = 'pause';

    // action
    this.play.button.addEventListener('click', () => this.actToggle(true));
    this.pause.button.addEventListener('click', () => this.actToggle(false));

    // keyboard action
    this.play.button.addEventListener('keydown', e => this.setFocus(e));
    this.pause.button.addEventListener('keydown', e => this.setFocus(e));
  }

  // toggle
  actToggle(activity) {
    // 有効化する対象のボタン
    const enable = activity ? 'play' : 'pause';
    this[enable].button.setAttribute('aria-selected', 'false');
    this[enable].button.disabled = true;
    // 無効化する対象のボタン
    const disable = !activity ? 'play' : 'pause';
    this[disable].button.setAttribute('aria-selected', 'true');
    this[disable].button.disabled = false;
    // コールバック
    const cb = this[enable].callback || _.noop;
    cb(this.target);
  }

  setFocus(e) {
    const target = e.currentTarget.index === 'play' ? 'pause' : 'play';
    setTimeout(() => {
      this[target].button.focus();
    }, 100);
  }
}

// EXPORT
export default (target, play, pause) => new PlayController(target, play, pause);
